export const trimText = (text, charactersToAppear, appendDots = true) => {
  if (text.length <= charactersToAppear) return text;

  const trimmedText = text.substr(0, charactersToAppear);
  return (appendDots && `${trimmedText}...`) || trimmedText;
};
